import { fetchLogin, selectAuth, selectAuthError, selectAuthLoading } from "@/entities/auth"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { FormInput } from "@/shared/ui/form-input"
import { SubmitHandler, useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from 'yup'
import { useEffect } from "react"
import WarningSvg from '@/shared/assets/images/Warning.svg'
import { getErrorMessage } from "@/shared/consts/error-codes"
import AuthPreview from '@/shared/assets/images/AuthPreview.png'
import LogoMonoSvg from '@/shared/assets/images/LogoMono.svg'

type Credentials = {
    login: string
    password: string
}

const schema = yup
    .object({
        login: yup.string().required("Введите логин"),
        password: yup.string().required("Введите пароль")
    })

export const AuthPage = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const authError = useAppSelector(selectAuthError)
    const isAuth = useAppSelector(selectAuth)

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema)
    })

    const onSubmit: SubmitHandler<Credentials> = (data) => {
        dispatch(fetchLogin(data))
    }

    useEffect(() => {
        if (isAuth) {
            navigate('/')
        }
    }, [isAuth])

    return (
        <div className="grid grid-cols-12 flex-1 w-full min-w-0 overflow-auto">
            <div className="col-span-6 relative bg-color-dark hidden xl:flex items-center justify-center">
                <img src={AuthPreview} className="object-cover absolute w-full h-full" />
                <LogoMonoSvg className="relative z-10" width={530} height={145} />
            </div>
            <div className="col-span-12 xl:col-span-6 flex items-center justify-center">
                <div className="box min-w-[600px]">
                    <div className="box_header font-mediumttf !mb-4">
                        Авторизация
                    </div>
                    {authError &&
                        <div className="bg-red-100 mb-3 p-4 flex items-center text-red-500 border-b-2 rounded-lg border-red-500">
                            <WarningSvg width={32} height={32} />
                            <div className="text-color-dark ml-2">
                                {getErrorMessage(authError?.error_id)}
                            </div>
                        </div>
                    }
                    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6">
                        <FormInput 
                            error={errors['login']}
                            placeholder="Введите логин"
                            register={register}
                            label="Логин" 
                            id={"login"} 
                            required={true}
                        />
                        <FormInput 
                            error={errors['password']}
                            placeholder="******"
                            register={register}
                            label="Пароль" 
                            type="password"
                            id={"password"} 
                            required={true}
                        />
                        <button type="submit" className="text-[22px] text-white justify-center inline-flex gap-2 w-full text-center bg-color-dark rounded-full py-5">
                            Войти
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}
